import React from 'react';
import Constants from 'js/Constants';
import Menu from 'js/components/elements/menu/Menu';
import { StatusIconActive, StatusIconPaused } from 'js/components/elements/icons/StatusIcons';
import { ServiceKey } from '@nexla/@types';
import { useServiceKeyProcesses } from 'new/components/settings/Authentication/ServiceKeys/useServiceKeyProcesses';
import { useDispatch } from 'react-redux';
import {
  activateServiceKey,
  deleteServiceKey,
  pauseServiceKey,
  rotateServiceKey,
} from 'js/actions';

const icon_style = { color: '#6D7E8F', fontSize: 19 };

type ServiceKeyMenuProps = { data: ServiceKey; showStatus?: boolean };
export function ServiceKeyDetailHeaderMenu(props: ServiceKeyMenuProps) {
  const dispatch = useDispatch();
  const { data } = props;
  const { isActivating, isPausing, isRotating } = useServiceKeyProcesses(data);

  if (!data) return null;

  let statusClassName: string;
  const serviceKeyID = data?.id;
  const status = data.status.toUpperCase();

  const _handleRotateClicked = () => {
    dispatch(rotateServiceKey(serviceKeyID));
  };

  const _handlePauseClicked = () => {
    dispatch(pauseServiceKey(serviceKeyID));
  };

  const _handleActivateClicked = () => {
    dispatch(activateServiceKey(serviceKeyID));
  };

  const _handleDeleteClicked = () => {
    dispatch(deleteServiceKey(serviceKeyID));
  };

  const menuItems = [
    {
      type: 'dialog',
      label: isRotating ? 'Rotating...' : 'Rotate',
      icon: <i aria-hidden className="fa fa-refresh" style={icon_style} />,
      disable: isRotating,
      dialogMessage: `Please confirm you want to rotate the Service key: ${data.name} (ID: ${data.id})`,
      discardLabel: 'Cancel',
      confirmLabel: 'Rotate',
      onClick: _handleRotateClicked,
    },
  ];

  switch (status) {
    case Constants.SourceStatus.ACTIVE:
      statusClassName = 'status-active';
      menuItems.push({
        dialogMessage: `Please confirm you want to pause the Service key: ${data.name} (ID: ${data.id})`,
        discardLabel: 'Cancel',
        confirmLabel: 'Pause',
        type: 'dialog',
        label: isPausing ? 'Pausing...' : 'Pause',
        icon: <StatusIconPaused />,
        disable: isPausing,
        onClick: _handlePauseClicked,
      });
      break;

    case Constants.SourceStatus.PAUSED:
      statusClassName = 'status-paused';
      menuItems.push({
        dialogMessage: `Please confirm you want to activate the Service key: ${data.name} (ID: ${data.id})`,
        discardLabel: 'Cancel',
        confirmLabel: 'Activate',
        type: 'dialog',
        label: isActivating ? 'Activating...' : 'Activate',
        icon: <StatusIconActive />,
        disable: isActivating,
        onClick: _handleActivateClicked,
      });
      break;

    default:
  }

  menuItems.push({
    disable: false,
    type: 'dialog',
    label: 'Delete',
    icon: <i className="fa fa-trash" style={icon_style} aria-hidden />,
    dialogMessage: `Please confirm you want to delete the Service Key ${data.name} (ID: ${data.id})`,
    discardLabel: 'Cancel',
    confirmLabel: 'Delete',
    onClick: _handleDeleteClicked,
  });

  return (
    <div className="detail-actions">
      <Menu items={menuItems} />
    </div>
  );
}
